// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__yeU7F","btnlight":"styles_btnlight__hsXM8","btndark":"styles_btndark__N4rz3"};